import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { DragulaService } from 'ng2-dragula/ng2-dragula';

import { Course } from '../../courses/shared/course';
import { CourseLectureService } from '../../courses/shared/course-lecture.service';
import { ListComponentBase } from '../../shared/base/list-component-base';
import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Lecture } from '../shared/lecture';

@Component({
  selector: 'app-lecture-list',
  templateUrl: './lecture-list.component.html',
  styleUrls: ['./lecture-list.component.scss'],
  viewProviders: [DragulaService]
})
export class LectureListComponent extends ListComponentBase implements OnInit, OnDestroy {
  @Input() lectures: Lecture[];
  @Input() course: Course;

  constructor(snackBar: MatSnackBar, dragulaService: DragulaService, private refService: CourseLectureService) {
    super(snackBar, dragulaService);
  }

  ngOnInit() {
    this._initSubscriptions();

    this.dragulaService.setOptions(this.bagName, {
      accepts: (el: Element, target: Element, source: Element, sibling: Element): boolean => {
        return !el.contains(target);
      },
      moves: (el: Element, container: Element, handle: Element): boolean => {
        return el.tagName.toLowerCase() === 'app-lecture' && handle.tagName.toLowerCase() === 'div';
      }
    });
  }

  ngOnDestroy() {
    this._dropSubscriptions();
  }

  get bagName(): string {
    return this.course.$key;
  }

  async onSubmit() {
    try {
      await this.refService.readChildAsObject(this.course.$key).$ref.transaction(course => {
        this.lectures.map((lecture, index) => course[lecture.$key].order = index);
        return course;
      });
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/lectures/lecture-list/lecture-list.component.ts